import { render, staticRenderFns } from "./Registered.vue?vue&type=template&id=825bd4fe"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"
import style0 from "./Registered.vue?vue&type=style&index=0&id=825bd4fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports